// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { pure } from 'recompose';

import Icon from 'app/common/components/Icon';
import 'app/common/components/Tag.scss';

import type { Node } from 'react';

import type { KindType } from 'app/common/types';

type Props = {
  backgroundColor?: string,
  iconAfter?: string,
  iconBefore?: string,
  textColor?: string,
  kind?: KindType,
  className?: string,

  // This is the preferred way of defining the type of children
  // (see https://flow.org/en/docs/react/children):
  children?: Node,
};

const bem = bemify('tag-v2');

const Tag = (props: Props) => {
  const {
    kind,
    className,
    children,
    iconAfter,
    iconBefore,
    textColor: color,
    backgroundColor,
    ...otherProps
  } = props;

  const iconAfterNode = !iconAfter ? null : (
    <Icon className={bem('__icon --after')} type={iconAfter} />
  );
  const iconBeforeNode = !iconBefore ? null : (
    <Icon className={bem('__icon --before')} type={iconBefore} />
  );
  return (
    <div
      className={bem(toModifiers(kind), className)}
      style={{
        color,
        backgroundColor,
      }}
      {...otherProps}
    >
      {iconBeforeNode}
      {children}
      {iconAfterNode}
    </div>
  );
};

// Use `pure` HOC to turn `Tag` into a pure component:
export default pure(Tag);
